// Generic function to generate filename with timestamp for any timezone
export const generateFilenameWithTimestamp = (baseFileName: string) => {
  // Use the Intl.DateTimeFormat API to get the current time in specified timezone
  const now = new Date();

  // Create formatter specifically for the provided timezone
  const formatterOptions = { timeZone: "Asia/Singapore" };

  // Get individual components in specified timezone
  const year = new Intl.DateTimeFormat("en", {
    ...formatterOptions,
    year: "numeric",
  }).format(now);
  const month = new Intl.DateTimeFormat("en", {
    ...formatterOptions,
    month: "2-digit",
  }).format(now);
  const day = new Intl.DateTimeFormat("en", {
    ...formatterOptions,
    day: "2-digit",
  }).format(now);
  const hours = new Intl.DateTimeFormat("en", {
    ...formatterOptions,
    hour: "2-digit",
    hour12: false,
  }).format(now);
  const minutes = new Intl.DateTimeFormat("en", {
    ...formatterOptions,
    minute: "2-digit",
  }).format(now);
  const seconds = new Intl.DateTimeFormat("en", {
    ...formatterOptions,
    second: "2-digit",
  }).format(now);

  // Clean up any potential formatting characters like slashes or colons
  const cleanYear = year.padStart(4, "0");
  const cleanMonth = month.replace(/[^0-9]/g, "").padStart(2, "0");
  const cleanDay = day.replace(/[^0-9]/g, "").padStart(2, "0");
  const cleanHours = hours.replace(/[^0-9]/g, "").padStart(2, "0");
  const cleanMinutes = minutes.replace(/[^0-9]/g, "").padStart(2, "0");
  const cleanSeconds = seconds.replace(/[^0-9]/g, "").padStart(2, "0");

  // Combine into the format: fileName_YYYYMMDDHHMMSS
  const timestamp = `${cleanYear}${cleanMonth}${cleanDay}${cleanHours}${cleanMinutes}${cleanSeconds}`;
  return `${baseFileName}_${timestamp}`;
};
